module.exports = __webpack_public_path__ + "media/images/lb/455-41d3f3ed43e3b0c263f47fa4686f36b1.svg";